module.exports = __webpack_public_path__ + "static/media/icon-estoque-rel-movimentacao.df2d5ace.png";